var __WEBPACK_NAMESPACE_OBJECT__ = lvflanders.bar.shared;